module.exports = __webpack_public_path__ + "static/media/quezishan_package.b831a127.png";